import React from 'react';
import { Button, Divider, makeStyles } from '@material-ui/core';
import { TK_TIPOS_ACAO_SELECAO_SERVICO, trackServiceSelectORA } from '../../shared/helper/tracker';
import { getServiceName, launch } from 'shared/helper/serviceLauncher';
import configuration from 'envConfig';
import { connect } from 'react-redux';
import { ErrorScreen } from './InfoScreen';
import store from 'store';
import { deslogarUsuario } from 'login/actions';
import LoadingCircular from './LoadingCircular';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.up('xs')]: {
      flexDirection: 'column',
    },  
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',     
    },
  },
  dataContainer: {
    display: 'flex',
    flexDirection: 'rown',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '8px'
  },
  dataTitle: {
    color: theme.shared.template.InfoScreen.primaryText.color,
    fontWeight: '600',
    fontSize: '1.2em',
  },
  dataCard: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',    
    borderRadius: '10px',    
    boxShadow: '0px 3px 6px #00000029',
    backgroundColor: theme.shared.template.InfoScreen.card.backgroundColor,
    opacity: '1',
    width: '100%',
    height: 'auto',
    padding: '8px 0'
  },
  dataCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    width: '100%',
    minHeight: '112px',
  },
  dataCardContainerGeral:{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    width: '100%',
    minHeight: '112px',
    [theme.breakpoints.up('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  dataCardContainerHr: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '10px',
  },
  dataCardTitle: {
    fontSize: '1.2em',
    fontWeight: '600',
    padding: '0 24px'
  },
  dataCardLabelBold: {
    fontSize: '1.2em',
    color: theme.shared.template.InfoScreen.primaryText.color,
    fontWeight: '600',
    marginBottom: '14px',
  },
  dataCardContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.up('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    width: '100%',
  },
  dataCardInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  dataCardLabel: {
    fontSize: '1.1em',
    color: theme.shared.template.InfoScreen.secondaryText.color,
    fontWeight: '600 !important',
    paddingRight: '5px',
  },
  dataCardText: {
    fontSize: '1.1em',
    color: theme.shared.template.InfoScreen.secondaryText.color,
    fontWeight: 'normal !important',
    marginBottom: '14px',
  },
  divider: {
    backgroundColor: '#e0e0e0',
  },
  inputBaseHover: {    
    padding: '0 8px',
    backgroundColor: theme.palette.background.colorContrast,
    "&:hover": {
      backgroundColor: theme.palette.background.colorButtonHover, 
    },
    border: 'none',
    margin: '0 !important',
    width: '180px'
  },
  laudo: {
    display: 'flex',    
    justifyContent: 'space-between',    
    padding: '8px 4px',
    width: '100%',        
    fontSize: '1em',
    paddingTop: '16px'
  },
  conteudo: {    
    padding: '16px 24px',
    backgroundColor: theme.palette.mode == 'dark' ? '#33333' : '#F8F8F8',
    width: '100%'
  }
}));

const handleSairClick = () => {  
    store.dispatch(deslogarUsuario())  
}

const DadosDivergentes = (props) => {
  const { data, loadingBasicInfo, message } = props;
  const classes = useStyles();

  const TEXTO_ERRO_ATUALIZACAO = "Atualização não realizada."
  const TEXTO_PROCURADOR = 'Serviço não disponível para o perfil de procurador.';

  const itemInss = {
    "sagService":"Atualização de Cadastro para Emissão de Senha de Meu INSS",
    "sigla":"ATUDIV",
    "weight":1

  }
  const servicoSemSenha = {
    "externalLink": "Atualizar Cadastro da Receita Federal",
    "url": configuration.urlAtualizacaoCadastralRFB,
    "weight": 1,
  }

  if (loadingBasicInfo) {
    return <LoadingCircular /> 
  }

  if (message && message === 'erro_procurador_atualizacao'){
    return <ErrorScreen
        primaryText={TEXTO_ERRO_ATUALIZACAO}
        action={handleSairClick}
        buttonText={'Sair do Meu INSS'}
        secondaryText={TEXTO_PROCURADOR}
    />
  }
  if (!message || message == ''){
    return (
      <div className={classes.container}>
      <div className={classes.dataContainer}>      
        <div className={classes.dataCard}>
          <div className={classes.dataCardContainerGeral}>
            <div className={classes.dataCardContainer} >
                  <div className={`${classes.dataCardLabelBold} ${classes.dataCardTitle}`}>
                    <span>Dados no INSS</span>
                  </div>
                  <div className={classes.conteudo}>

                    {data && data.map((item, index) => (
                
                      <div key={index}>
                      <div className={classes.dataCardInfo}>
                        <div className={classes.dataCardLabel}>
                          <span>{item.tipo}</span>
                        </div>
                        <div className={classes.dataCardText}>
                          <span>{item.INSS}</span>
                        </div>
                      </div>
                     </div>          
                    ))}
                  </div>
                
             
              <div className={classes.laudo}>
                <span></span>
                <Button
                  variant="text"
                  className={classes.inputBaseHover}
                  onClick={() => {
                    trackServiceSelectORA(TK_TIPOS_ACAO_SELECAO_SERVICO.HIGHLIGHT, getServiceName(itemInss)); 
                    launch(itemInss, "DADOS_DIVERGENTES")                    
                  }}
                  startIcon
                  > 
                <i class="fas fa-download" style={{ padding: '0 4px' }}></i>
                 Atualizar no INSS
                </Button>
              </div>  
            </div>
          </div>
        </div>
      </div>
      <div className={classes.dataContainer}>      
        <div className={classes.dataCard}>
          <div className={classes.dataCardContainerGeral}>           
            <div className={classes.dataCardContainer}>
              <div className={`${classes.dataCardLabelBold} ${classes.dataCardTitle}`}>
                <span>Dados na Receita Federal do Brasil</span>
              </div>
              <div className={classes.conteudo}>

                {data && data.map((item, index) => (
                  
                  <div key={index}>
                  <div className={classes.dataCardInfo}>
                    <div className={classes.dataCardLabel}>
                      <span>{item.tipo}</span>
                    </div>
                    <div className={classes.dataCardText}>
                      <span>{item.ReceitaFederal}</span>
                    </div>
                  </div>
                 </div>          
                ))}
              </div>
             

                <div className={classes.laudo}>
                <span></span>
                  <Button
                    variant="text"
                    className={classes.inputBaseHover}
                    onClick={() => {
                      trackServiceSelectORA(TK_TIPOS_ACAO_SELECAO_SERVICO.HIGHLIGHT, getServiceName(servicoSemSenha));
                      launch(servicoSemSenha, "DADOS_DIVERGENTES")                      
                    }}
                    startIcon
                    > 
                  <i class="fas fa-download" style={{ padding: '0 4px' }}></i>
                   Atualizar na Receita
                  </Button>
                </div>  
              </div>
          </div>
        </div>
      </div>
      </div>    
    );
  }
};

const mapStateToProps = state => ({    
    loadingBasicInfo: state.session.loadingBasicInfo,        
    message: state.session.message    
});

export default connect(mapStateToProps)(DadosDivergentes);
